//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';
import { PageUtils } from "./helpers/page-utils";

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
    const siteHeader = document.getElementById('siteHeader');
    if (scrollCta) {
        scrollCta.classList.remove('hidden');
    }
    if (hubspotChat) {
        hubspotChat.classList.remove('opacity-0','pointer-events-none');
    }
    if (siteHeader) {
        const headerHeight = siteHeader.getBoundingClientRect().height;
        const scrollDistance = window.scrollY || document.documentElement.scrollTop;

        if (scrollDistance <= headerHeight) {
            siteHeader.dataset.visible = 'true';
        }
    }
    setTimeout(() => {
        lightbox.dataset.hidden = 'true';
    }, 300);
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();

    const docBody = document.body;
    const siteHeader = document.getElementById('siteHeader');
    const scrollCta = document.querySelector('button[data-scroll-cta]');
    const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
    if (scrollCta) {
        scrollCta.classList.add('hidden');
    }
    if (hubspotChat) {
        hubspotChat.classList.add('opacity-0','pointer-events-none');
    }
    siteHeader.dataset.visible = 'false';
    docBody.dataset.navVisible = 'false';

    setTimeout(() => {
        lightbox.dataset.visible = 'true';
    }, 50);
}

function documentKeydownHandler(event, lightbox, splide) {
    if (lightbox.dataset.hidden === 'false') {
        if (event.key === 'Escape') {
            closeLightBox(lightbox);
        }
        else if (event.key === 'ArrowRight') {
            splide.go('+1');
        }
        else if (event.key === 'ArrowLeft') {
            splide.go('-1');
        }
    }
}

window.addEventListener('load', () => {
    const availableCarousels = document.querySelectorAll('.splide');
    const gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    const testimonialPanel = document.querySelectorAll('.testimonial-panel-slider');
    const miniCardPanel = document.querySelectorAll('.card-panel-mini');
    const largeCardPanel = document.querySelectorAll('.card-panel-large');
    const pricingCardPanel = document.querySelectorAll('.card-panel-pricing');
    const estateCardPanel = document.querySelectorAll('.card-panel-estate');
    const categoriesCardPanel = document.querySelectorAll('.card-panel-categories');
    const cardMapPanel = document.querySelectorAll('.card-panel-map');
    const homeSpecificationsPanel = document.querySelectorAll('.home-specifications-panel');
    const relatedHomesCardPanel = document.querySelectorAll('.card-panel-related-homes');
    const homeTestimonialPanel = document.querySelectorAll('.home-testimonial-panel');
    const facadesPanel = document.querySelectorAll('.facades-panel');

    if (availableCarousels.length) {
        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            const galleryThumbnails = panel.querySelectorAll('.gallery-panel-image');
            const lightbox = panel.querySelector('[data-lightbox="gallery-panel"]');
            const requiredSplidesPresent = !!(panel.querySelector('.gallery-lightbox-splide') && panel.querySelector('.gallery-splide'));

            if (requiredSplidesPresent) {
                const galleryLightboxSplide = new Splide(panel.querySelector('.gallery-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    arrows: true,
                    pagination: false,
                    arrowPath: 'M8.32248 20.9138L29.4625 20.9138L19.3525 31.0238C18.9925 31.3838 18.9925 31.9538 19.3525 32.3138C19.7125 32.6738 20.2825 32.6638 20.6425 32.3138L32.3125 20.6438C32.3925 20.5638 32.4625 20.4638 32.5025 20.3538C32.5925 20.1338 32.5925 19.8838 32.5025 19.6538C32.4625 19.5438 32.3925 19.4438 32.3125 19.3638L20.6425 7.69383C20.4625 7.51383 20.2325 7.42383 20.0025 7.42383C19.7725 7.42383 19.5325 7.51383 19.3625 7.69383C19.0025 8.04383 19.0025 8.62383 19.3625 8.98383L29.4725 19.1038L8.33249 19.1038C7.83249 19.1038 7.42249 19.5138 7.42249 20.0138C7.42249 20.5138 7.83249 20.9238 8.33249 20.9238L8.32248 20.9138Z',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative flex items-center justify-center z-3 rounded-l-lg w-14 h-16 p-2 bg-black/20 2.5xl:bg-transparent 2.5xl:p-0 2.5xl:w-10 2.5xl:h-12 fill-current text-white disabled:text-white/20 transition-all duration-300 hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2.5xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2.5xl:-right-16',
                    },
                });

                const gallerySplide = new Splide(panel.querySelector('.gallery-splide'), {
                    type: 'loop',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    autoplay: true,
                    interval: 10000,
                    gap: '2rem',
                    padding: '2rem',
                    destroy: true,
                    arrowPath: 'M8.32248 20.9138L29.4625 20.9138L19.3525 31.0238C18.9925 31.3838 18.9925 31.9538 19.3525 32.3138C19.7125 32.6738 20.2825 32.6638 20.6425 32.3138L32.3125 20.6438C32.3925 20.5638 32.4625 20.4638 32.5025 20.3538C32.5925 20.1338 32.5925 19.8838 32.5025 19.6538C32.4625 19.5438 32.3925 19.4438 32.3125 19.3638L20.6425 7.69383C20.4625 7.51383 20.2325 7.42383 20.0025 7.42383C19.7725 7.42383 19.5325 7.51383 19.3625 7.69383C19.0025 8.04383 19.0025 8.62383 19.3625 8.98383L29.4725 19.1038L8.33249 19.1038C7.83249 19.1038 7.42249 19.5138 7.42249 20.0138C7.42249 20.5138 7.83249 20.9238 8.33249 20.9238L8.32248 20.9138Z',
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: false,
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: false,
                        },
                        639: {
                            perPage: 1,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: false,
                        },
                    },
                });

                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');
                    const lightboxProgressBar = lightbox.querySelector('[data-carousel-progress]');

                    // Closes lightbox on backdrop/close button press
                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }

                    // Updates carousel progress bar width
                    if (lightboxProgressBar) {
                        galleryLightboxSplide.on('mounted move', function () {
                            let end = galleryLightboxSplide.Components.Controller.getEnd() + 1;
                            lightboxProgressBar.style.width = String(100 * (galleryLightboxSplide.index + 1) / end) + '%';
                        });
                    }

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => documentKeydownHandler(e, lightbox, galleryLightboxSplide));
                }

                // Opens lightbox and navigates carousel to the thumbnail that was pressed
                for ( let thumbnail of galleryThumbnails ) {
                    thumbnail.addEventListener('click', () => {
                        if (thumbnail.dataset.slide.length) {
                            galleryLightboxSplide.go(parseInt(thumbnail.dataset.slide));
                        }
                        openLightBox(lightbox);
                    });
                }

                galleryLightboxSplide.mount();
                gallerySplide.mount()
                gallerySplide.sync(galleryLightboxSplide);
            }
        }
        // END GALLERY PANEL SLIDER

        // START TESTIMONIAL PANEL SLIDER
        for ( const panel of testimonialPanel ) {
            const splideElement = panel.querySelector('.testimonial-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;

                const testimonialSplide = new Splide(panel.querySelector('.testimonial-panel-splide'), {
                    type: 'loop',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 2,
                    perMove: 1,
                    pagination: false,
                    autoplay: true,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 2,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 1,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            perPage: mobileSlidePerPage,
                            focus: 'right',
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });

                // for custom next / prev button locations
                const customNextButtons = panel.querySelectorAll('button[data-splide-go="next"]');
                const customPrevButtons = panel.querySelectorAll('button[data-splide-go="prev"]');

                // Add click listeners for custom next and previous buttons
                customNextButtons.forEach(button => button.addEventListener('click', () => testimonialSplide.go('+1')));
                customPrevButtons.forEach(button => button.addEventListener('click', () => testimonialSplide.go('-1')));

                testimonialSplide.mount();
            }
        }
        // END TESTIMONIAL PANEL SLIDER

        // START HOME DESIGN TESTIMONIAL PANEL SLIDER
        for ( const panel of homeTestimonialPanel ) {
            const splideElement = panel.querySelector('.testimonial-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;

                const homeTestimonialSplide = new Splide(panel.querySelector('.testimonial-panel-splide'), {
                    type: 'loop',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 1,
                    perMove: 1,
                    pagination: false,
                    autoplay: true,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 1,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 1,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 1,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            focus: 'right',
                            perPage: mobileSlidePerPage,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });


                // for custom next / prev button locations
                const customNextButtons = panel.querySelectorAll('button[data-splide-go="next"]');
                const customPrevButtons = panel.querySelectorAll('button[data-splide-go="prev"]');

                // Add click listeners for custom next and previous buttons
                customNextButtons.forEach(button => button.addEventListener('click', () => homeTestimonialSplide.go('+1')));
                customPrevButtons.forEach(button => button.addEventListener('click', () => homeTestimonialSplide.go('-1')));

                homeTestimonialSplide.mount();
            }
        }
        // END HOME DESIGN TESTIMONIAL PANEL SLIDER

        // START MINI CARD PANEL SLIDER
        for ( const panel of miniCardPanel ) {
            const splideElement = panel.querySelector('.card-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;
                const autoPlay = splideElement.dataset.autoPlay !== undefined
                    ? splideElement.dataset.autoPlay.toLowerCase() === 'true'
                    : true;

                const miniCardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                    type: 'loop',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    autoplay: autoPlay,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 2,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            perPage: mobileSlidePerPage,
                            focus: 'right',
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });

                miniCardSplide.mount();
            }

        }
        // END MINI CARD PANEL SLIDER

        // START LARGE CARD PANEL SLIDER
        for ( const panel of largeCardPanel ) {
            const splideElement = panel.querySelector('.card-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;
                const autoPlay = splideElement.dataset.autoPlay !== undefined
                    ? splideElement.dataset.autoPlay.toLowerCase() === 'true'
                    : true;

                const largeCardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                    type: 'loop',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    autoplay: autoPlay,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 2,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            perPage: mobileSlidePerPage,
                            focus: 'right',
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });

                largeCardSplide.mount();
            }
        }
        // END LARGE CARD PANEL SLIDER

        // START PRICING CARD PANEL SLIDER
        for ( const panel of pricingCardPanel ) {
            const splideElement = panel.querySelector('.card-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;

                const pricingCardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                    type: 'loop',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    autoplay: true,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 2,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            perPage: mobileSlidePerPage,
                            focus: 'right',
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });

                pricingCardSplide.mount();
            }
        }
        // END PRICING CARD PANEL SLIDER

        // START ESTATE CARD PANEL SLIDER
        for ( const panel of estateCardPanel ) {
            const splideElement = panel.querySelector('.card-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;

                const estateCardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                    type: 'slide',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    autoplay: true,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 2,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            perPage: mobileSlidePerPage,
                            focus: 'right',
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });

                estateCardSplide.mount();
            }
        }
        // END ESTATE CARD PANEL SLIDER

        // START RELATED HOMES PANEL SLIDER
        for ( const panel of relatedHomesCardPanel ) {
            const splideElement = panel.querySelector('.card-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;

                const relatedHomesCardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                    type: 'slide',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    autoplay: true,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 2,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            perPage: mobileSlidePerPage,
                            focus: 'right',
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });

                relatedHomesCardSplide.mount();
            }
        }
        // END RELATED HOMES CARD PANEL SLIDER

        // START MAP CARD PANEL SLIDER
        for ( const panel of cardMapPanel ) {
            const splideElement = panel.querySelector('.card-panel-splide');

            if (splideElement) {
                const mobileSlidePerPage = Number(splideElement.dataset.totalSlides) === 1 ? 1 : 1.1;

                const mapCardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                    type: 'slide',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: true,
                    perPage: 2,
                    perMove: 1,
                    pagination: true,
                    autoplay: true,
                    gap: '2rem',
                    padding: '2rem',
                    interval: 10000,
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1279: {
                            perPage: 2,
                            gap: '2rem',
                            padding: '2rem',
                        },
                        1023: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        767: {
                            perPage: 2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                        639: {
                            autoplay: false,
                            type: 'slide',
                            perPage: mobileSlidePerPage,
                            focus: 'right',
                            padding: '1.5rem',
                            gap: '1.5rem',
                        },
                    },
                });

                mapCardSplide.mount();
            }
        }
        // END MAP CARD PANEL SLIDER

        // START HOME SPECIFICATIONS PANEL SLIDER
        for ( const panel of homeSpecificationsPanel ) {
            const splideElement = panel.querySelector('.home-specifications-offer-splide');

            if (splideElement) {
                const homeSpecificationsOfferSplide = new Splide(panel.querySelector('.home-specifications-offer-splide'), {
                    type: 'loop',
                    speed: 1000,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 1,
                    perMove: 1,
                    pagination: true,
                    autoplay: true,
                    gap: '2rem',
                    padding: '0',
                    interval: 5000,
                    classes: {
                        pagination: 'splide__pagination absolute bottom-4 left-0 w-full px-6 py-2 h-auto flex justify-center items-center gap-2',
                        page: 'splide__pagination__page rounded-full shadow-sm backdrop-blur-md w-3 h-3 border-green-brand border-solid border bg-green-brand/10 hover:bg-green-brand/30 [&.is-active]:!bg-green-brand/100 transition-all duration-150 ease-in-out',
                    },
                });

                homeSpecificationsOfferSplide.mount();
            }
        }
        // END HOME SPECIFICATIONS PANEL SLIDER

        // START LARGE CARD PANEL SLIDER
        for ( const panel of categoriesCardPanel ) {
            const cardSplideContainers = panel.querySelectorAll('.card-panel-splide-container');

            if (cardSplideContainers.length > 0) {
                for (const cardSplideContainer of cardSplideContainers) {
                    const cardSplideElement = cardSplideContainer.querySelector('.card-panel-splide');

                    if (cardSplideElement) {
                        const mobileSlidePerPage = Number(cardSplideElement.dataset.totalSlides) === 1 ? 1 : 1.1;
                        const autoPlay = cardSplideElement.dataset.autoPlay !== undefined
                            ? cardSplideElement.dataset.autoPlay.toLowerCase() === 'true'
                            : true;

                        const categoryCardSplide = new Splide(cardSplideContainer.querySelector('.card-panel-splide'), {
                            type: 'slide',
                            speed: 750,
                            direction: 'ltr',
                            pauseOnHover: true,
                            arrows: false,
                            perPage: 3,
                            perMove: 1,
                            pagination: false,
                            autoplay: autoPlay,
                            gap: '2rem',
                            padding: '2rem',
                            interval: 10000,
                            classes: {
                                pagination: 'hidden',
                                arrows: 'hidden',
                            },
                            breakpoints: {
                                1279: {
                                    perPage: 2,
                                    gap: '2rem',
                                    padding: '2rem',
                                },
                                1023: {
                                    perPage: 2,
                                    padding: '1.5rem',
                                    gap: '1.5rem',
                                },
                                767: {
                                    perPage: 2,
                                    padding: '1.5rem',
                                    gap: '1.5rem',
                                },
                                639: {
                                    autoplay: false,
                                    type: 'slide',
                                    perPage: mobileSlidePerPage,
                                    focus: 'right',
                                    padding: '1.5rem',
                                    gap: '1.5rem',
                                },
                            },
                        });

                        categoryCardSplide.mount();
                    }
                }
            }
        }
        // END LARGE CARD PANEL SLIDER

        // START FACADE PANEL SLIDER
        for ( const panel of facadesPanel ) {
            const facadeSplideElements = panel.querySelectorAll('.facade-splide');

            if (facadeSplideElements.length > 0) {
                for (const facadeSplideElement of facadeSplideElements) {

                    const facadeSplide = new Splide(facadeSplideElement, {
                        type: 'fade',
                        speed: 750,
                        direction: 'ltr',
                        pauseOnHover: true,
                        arrows: true,
                        perPage: 1,
                        perMove: 1,
                        pagination: true,
                        autoplay: true,
                        rewind: true,
                        gap: '0',
                        padding: '0',
                        interval: 7500,
                        arrowPath: 'M8.32248 20.9138L29.4625 20.9138L19.3525 31.0238C18.9925 31.3838 18.9925 31.9538 19.3525 32.3138C19.7125 32.6738 20.2825 32.6638 20.6425 32.3138L32.3125 20.6438C32.3925 20.5638 32.4625 20.4638 32.5025 20.3538C32.5925 20.1338 32.5925 19.8838 32.5025 19.6538C32.4625 19.5438 32.3925 19.4438 32.3125 19.3638L20.6425 7.69383C20.4625 7.51383 20.2325 7.42383 20.0025 7.42383C19.7725 7.42383 19.5325 7.51383 19.3625 7.69383C19.0025 8.04383 19.0025 8.62383 19.3625 8.98383L29.4725 19.1038L8.33249 19.1038C7.83249 19.1038 7.42249 19.5138 7.42249 20.0138C7.42249 20.5138 7.83249 20.9238 8.33249 20.9238L8.32248 20.9138Z',
                        classes: {
                            pagination: 'splide__pagination absolute bottom-0 left-4 w-full max-w-max rounded-t-md bg-green-brand/50 backdrop-blur-md px-8 py-2 h-auto flex justify-center items-center gap-2',
                            page: 'splide__pagination__page rounded-full shadow-sm backdrop-blur-md w-3 h-3 border-green-brand border-solid border bg-cream/50 hover:bg-cream/80 [&.is-active]:!bg-cream/100 transition-all duration-150 ease-in-out',
                            arrows: 'splide__arrows absolute bottom-0 left-5 h-8 w-full flex items-center justify-between',
                            arrow: 'splide__arrow relative flex items-center justify-center z-3 w-6 h-6 fill-current text-cream disabled:text-cream/20 transition-all origin-center duration-300 hover:scale-110 disabled:!scale-100 active:scale-[1.2] active:duration-75',
                            prev: 'splide__arrow--prev left-0 rotate-180',
                            next: 'splide__arrow--next right-0',
                        },
                    });

                    facadeSplide.mount();

                    // Adjust arrow container width dynamically
                    const slidesCount = facadeSplideElement.querySelectorAll('.splide__slide').length;
                    const arrowContainer = facadeSplideElement.querySelector('.splide__arrows');

                    if (arrowContainer) {
                        const computedWidth = (slidesCount * 1.25) + 1 + 2; // in rem
                        arrowContainer.style.width = `${computedWidth}rem`;
                    }
                }
            }
        }
        // END FACADE PANEL SLIDER

    }
});
